import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser?.email) {
          config.headers['x-user-email'] = parsedUser.email;
        }
      } catch (error) {
        console.warn('Erro ao ler usuário do storage:', error);
      }
    }

    if (config.url?.includes('username')) {
      console.log('[API REQUEST]', {
        method: config.method,
        url: config.url,
        baseURL: config.baseURL,
        fullURL: `${config.baseURL}${config.url}`,
      });
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    // /security/2fa/verify também devolve 401 (TWO_FACTOR_TOKEN_EXPIRED) sem nenhuma sessão
    // envolvida ainda — quem chama (LoginTwoFactor) trata esse erro com a mensagem certa e
    // navega de propósito; o redirect genérico daqui embaixo atropelaria isso com um reload cru.
    const skipRedirect = ['/user/login', '/user/new', '/user/reset-password', '/security/2fa/verify'].some(
      (path) => requestUrl.includes(path)
    );

    if (status === 401 && !skipRedirect) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(new Error('Sessão expirada. Faça login novamente.'));
    }

    return Promise.reject(error);
  }
);

export default api;
